// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v2/create_user.proto

/* oxlint-disable */
import { ApiUser } from "./user";

/** Request message for CreateUser (POST /v2/users). */
export interface ApiCreateUserRequest {
  /** User payload wrapped in the user key as required by the API. */
  readonly user: ApiCreateUserRequestCreateUserPayload | null;
}

/** Payload matching the { "user": ... } request body envelope. */
export interface ApiCreateUserRequestCreateUserPayload {
  /** Email address used for email-based sign-up. */
  readonly email?:
    | string
    | null
    | undefined;
  /** Phone number supplied during registration when available. */
  readonly phoneNumber?:
    | string
    | null
    | undefined;
  /** Locale selected for the newly created user. */
  readonly locale?:
    | string
    | null
    | undefined;
  /** Password chosen by the user when using password-based sign-up. */
  readonly password?:
    | string
    | null
    | undefined;
  /** OpenID token used for federated sign-up flows. */
  readonly openidToken?:
    | string
    | null
    | undefined;
  /** Email confirmation code used for email-based sign-up. */
  readonly code?:
    | string
    | null
    | undefined;
  /** Invite login token used by invitation-based sign-up flows. */
  readonly loginToken?:
    | string
    | null
    | undefined;
  /** Timezone selected for the newly created user when available. */
  readonly timezone?: string | null | undefined;
}

/** Response message for CreateUser. */
export interface ApiCreateUserResponse {
  /** Newly created or reused user data returned by the API. */
  readonly user: ApiUser | null;
}

export const ApiCreateUserRequest: MessageFns<ApiCreateUserRequest> = {
  fromJSON(object: any): ApiCreateUserRequest {
    return { user: isSet(object.user) ? ApiCreateUserRequestCreateUserPayload.fromJSON(object.user) : null };
  },

  toJSON(message: ApiCreateUserRequest): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiCreateUserRequestCreateUserPayload.toJSON(message.user);
    }
    return obj;
  },
};

export const ApiCreateUserRequestCreateUserPayload: MessageFns<ApiCreateUserRequestCreateUserPayload> = {
  fromJSON(object: any): ApiCreateUserRequestCreateUserPayload {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : null,
      phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : null,
      locale: isSet(object.locale) ? globalThis.String(object.locale) : null,
      password: isSet(object.password) ? globalThis.String(object.password) : null,
      openidToken: isSet(object.openid_token) ? globalThis.String(object.openid_token) : null,
      code: isSet(object.code) ? globalThis.String(object.code) : null,
      loginToken: isSet(object.login_token) ? globalThis.String(object.login_token) : null,
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : null,
    };
  },

  toJSON(message: ApiCreateUserRequestCreateUserPayload): unknown {
    const obj: any = {};
    if (message.email !== undefined && message.email !== null) {
      obj.email = message.email;
    }
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    if (message.locale !== undefined && message.locale !== null) {
      obj.locale = message.locale;
    }
    if (message.password !== undefined && message.password !== null) {
      obj.password = message.password;
    }
    if (message.openidToken !== undefined && message.openidToken !== null) {
      obj.openid_token = message.openidToken;
    }
    if (message.code !== undefined && message.code !== null) {
      obj.code = message.code;
    }
    if (message.loginToken !== undefined && message.loginToken !== null) {
      obj.login_token = message.loginToken;
    }
    if (message.timezone !== undefined && message.timezone !== null) {
      obj.timezone = message.timezone;
    }
    return obj;
  },
};

export const ApiCreateUserResponse: MessageFns<ApiCreateUserResponse> = {
  fromJSON(object: any): ApiCreateUserResponse {
    return { user: isSet(object.user) ? ApiUser.fromJSON(object.user) : null };
  },

  toJSON(message: ApiCreateUserResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiUser.toJSON(message.user);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
